<template>
  <section class="goto-payment">
  </section>
</template>

<script>
export default {
  name: 'GotoPayment',

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  created() {
    this.goto();
  },

  methods: {
    async goto() {
      this.$toast.loading('正在跳转...');

      const info = await this.getOrderProductType();

      if (!(info.type || info.id)) {
        this.$toast.clear();
        this.$toast.fail('获取订单信息失败！');
        this.toOrderPage();

        return;
      }

      // 特殊处理id 56
      if (+info.id === 56) {
        setTimeout(() => {
          this.$router.replace(`/order/${this.id}`);
        }, 500);
        return
      }

      let url;

      if (info.type == 3) {
        // 定金品类
        url = '/api/musicService/musicmall/payOrderDeposit';
      }
      else {
        url = '/api/musicService/musicmall/payOrder';
      }

      const { code, data, msg } = await this.$fetch(url, {
        method: 'post',
        data: {
          paytype: this.$route.query.payment_type || 'alipay',
          orderid: this.id
        }
      });

      if (code == 1) {
        window.location.href = data;
      }
      else {
        this.$toast.clear();
        this.$toast.fail(msg);
        this.toOrderPage();
      }
    },

    async getOrderProductType() {
      const { code, data } = await this.$fetch('/api/musicService/musicmall/getOrderInfo', {
        data: {
          orderid: this.id
        }
      });

      if (code == 1) {
        return data.product_info
      }
      else {
        return {};
      }
    },

    toOrderPage() {
      setTimeout(() => {
        this.$router.replace(`/order/${this.id}`);
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped>
.goto-payment {
  background-color: #f8f8f8;
}
</style>
